/**
 * 열화상 요약 온도값을 화면 표시용으로 포맷한다.
 *
 * @param {number|string|null|undefined} value
 * @returns {string}
 */
export function formatThermalStatValue(value) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return '-';
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? `${numericValue.toFixed(1)} ℃` : '-';
}
